import { useState, useEffect } from 'react';
import profileApi from '../api/profileApi';

export const useProfile = (userId) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProfile = async () => {
    if (!userId) return;
    
    try {
      setLoading(true);
      setError(null);
      
      const profileData = await profileApi.getCompleteProfile(userId);
      setProfile(profileData);
    } catch (err) {
      setError(err.message || 'Failed to fetch profile data');
      console.error('Profile fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  const refreshProfile = async () => {
    await fetchProfile();
  };

  useEffect(() => {
    fetchProfile();
  }, [userId]);

  return {
    profile,
    loading,
    error,
    refreshProfile
  };
};

// Hook for specific profile sections
export const useProfileSection = (userId, section) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSection = async () => {
      if (!userId) return;
      
      try {
        setLoading(true);
        setError(null);
        
        let result;
        switch (section) {
          case 'basic':
            result = await profileApi.getBasicProfile(userId);
            break;
          case 'bookings':
            result = await profileApi.getBookingStats(userId);
            break;
          case 'payments':
            result = await profileApi.getPaymentDetails(userId);
            break;
          case 'preferences':
            result = await profileApi.getPreferences(userId);
            break;
          case 'subscription':
            result = await profileApi.getSubscriptionInfo(userId);
            break;
          case 'settings':
            result = await profileApi.getSettings(userId);
            break;
          default:
            throw new Error('Invalid profile section');
        }
        
        setData(result);
      } catch (err) {
        setError(err.message || `Failed to fetch ${section} data`);
        console.error(`${section} fetch error:`, err);
      } finally {
        setLoading(false);
      }
    };

    fetchSection();
  }, [userId, section]);

  return {
    data,
    loading,
    error
  };
};
